import { ApiUrlConstants } from 'src/app/common/constants/api.constants';
import { catchError } from 'rxjs/internal/operators';
import { Observable } from 'rxjs/Observable';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./cache.service";
export class StorePortalFeatureService {
    constructor(httpClient, _cacheService) {
        this.httpClient = httpClient;
        this._cacheService = _cacheService;
    }
    /**
   * To get Store portal features by store Id and portal id
   * @returns Observable
   */
    getStorePortalFeatures(storeId, portalId) {
        const getStorePortals = ApiUrlConstants.configurationApiUrl + 'stores/' +
            storeId + '/portals/' + portalId + '/features';
        return this.httpClient
            .get(decodeURIComponent(encodeURIComponent(getStorePortals)))
            .pipe(catchError(this.handleErrorObservable)).toPromise();
    }
    /**
     * To handle the obervable error response
     * @param  {Response|any} error
     */
    handleErrorObservable(error) {
        return Observable.throw(error);
    }
}
StorePortalFeatureService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StorePortalFeatureService_Factory() { return new StorePortalFeatureService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.CacheService)); }, token: StorePortalFeatureService, providedIn: "root" });
